import React, { Fragment, useState } from "react";
import "../../templateform/templateform.css";
import Accordion from "react-bootstrap/Accordion";
import Selectplan from "pages/selectplan";


function DomainPlan(props) {
    const { setDomainSelectShow } = props;


    return (
        < div className="card-body">
            <form>
                <div className="form-group">
                    <Selectplan />
                </div>
            </form>
        </div>
    );
}
export default DomainPlan;
